import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function ApiTokenCreateDialog({ open, onOpenChange, onSubmit, submitting }) {
  const [name, setName] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { name };
    if (expiresAt) payload.expires_at = new Date(`${expiresAt}T23:59:59Z`).toISOString();
    const created = await onSubmit(payload);
    if (created) {
      setName("");
      setExpiresAt("");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="api-token-create-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading font-bold text-xl tracking-tight text-gray-900">New API Token</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-xs font-medium text-gray-600">Name *</Label>
            <Input
              data-testid="api-token-form-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Partner Website - Inventory Feed"
              className="mt-1.5 border-gray-300 focus-visible:ring-brand-500"
            />
          </div>
          <div>
            <Label className="text-xs font-medium text-gray-600">Expiration Date *</Label>
            <Input
              data-testid="api-token-form-expires-at"
              type="date"
              required
              min={new Date().toISOString().slice(0, 10)}
              value={expiresAt}
              onChange={(e) => setExpiresAt(e.target.value)}
              className="mt-1.5 border-gray-300 focus-visible:ring-brand-500"
            />
          </div>
          <p className="text-xs text-gray-400">
            The token grants read-only access to the product inventory list (GET /api/inventory) only.
          </p>
          <DialogFooter className="pt-1">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-gray-300">Cancel</Button>
            <Button type="submit" disabled={submitting} data-testid="api-token-form-submit" className="bg-[#1677ff] hover:bg-[#0958d9] transition-colors">
              {submitting ? "Creating..." : "Create Token"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
